// extracted by mini-css-extract-plugin
module.exports = {"cardDisplay":"PaymentMethod_cardDisplay__25rYM","cardDisplayImage":"PaymentMethod_cardDisplayImage__1vEnQ","cardText":"PaymentMethod_cardText__9FZys"};